import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/tablet-landscape.svg'


const _hoisted_1 = { class: "overlay warning--portrait" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("p", null, null, 512), [
      [_directive_translate, `general.switch_orientation`]
    ]),
    _hoisted_2
  ]))
}